var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.6449 9.49119C19.6449 9.55919 19.112 16.3 18.8076 19.1369C18.6169 20.8778 17.4946 21.9338 15.8111 21.9638C14.5176 21.9928 13.2514 22.0028 12.0055 22.0028C10.6829 22.0028 9.38936 21.9928 8.1338 21.9638C6.50672 21.9248 5.38342 20.8478 5.20253 19.1369C4.88936 16.29 4.36613 9.55919 4.35641 9.49119C4.34668 9.2862 4.41281 9.09121 4.54703 8.93321C4.67929 8.78722 4.86991 8.69922 5.07026 8.69922H18.9408C19.1402 8.69922 19.3211 8.78722 19.464 8.93321C19.5973 9.09121 19.6644 9.2862 19.6449 9.49119Z",
    fill: "#D01400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.97881C21 5.56783 20.6761 5.24584 20.2871 5.24584H17.3714C16.7781 5.24584 16.2627 4.82385 16.1304 4.22888L15.967 3.4999C15.7385 2.61893 14.9498 2.00195 14.0647 2.00195H9.93624C9.0415 2.00195 8.26054 2.61893 8.02323 3.5479L7.87054 4.22988C7.7373 4.82385 7.22185 5.24584 6.62957 5.24584H3.71385C3.32386 5.24584 3 5.56783 3 5.97881V6.3588C3 6.75979 3.32386 7.09177 3.71385 7.09177H20.2871C20.6761 7.09177 21 6.75979 21 6.3588V5.97881Z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bd56e6055c2b40fa26c760b38f1a8b97.svg";
export { ForwardRef as ReactComponent };